import React, { useContext, useState } from 'react';
import { Grid, InputLabel } from '@material-ui/core';
import { SecondaryButton, SelectBox, TextBox } from '../../../Core/FormInput';
import AppContext from '../../../App/AppContext';
import { copyInspectionSheetType } from '../../../Core/Service/vehicleChecks';

// Copies an existing inspection check (with its sections) into a new one.
// typeList is the same list that drives the tabs, so it always matches what is on screen.
const CopyInspectionTypeModal = ({ typeList = [], onClose }) => {
    const { showToast } = useContext(AppContext);
    const [state, setState] = useState({
        sourceInspectionSheetTypeID: '',
        newInspectionSheetTypeName: '',
        btnLoader: false
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    const handleCopy = async () => {
        if (!state.sourceInspectionSheetTypeID) {
            showToast('Please select an inspection check to copy from.');
            return;
        }
        if (!state.newInspectionSheetTypeName || !state.newInspectionSheetTypeName.trim()) {
            showToast('Please enter a name for the new inspection check.');
            return;
        }
        const duplicate = typeList.find(
            (t) => (t.name || '').toLowerCase().trim() === state.newInspectionSheetTypeName.toLowerCase().trim()
        );
        if (duplicate) {
            showToast('An inspection check with that name already exists.');
            return;
        }

        setState((st) => ({ ...st, btnLoader: true }));
        try {
            const res = await copyInspectionSheetType({
                SourceInspectionSheetTypeID: Number(state.sourceInspectionSheetTypeID),
                NewInspectionSheetTypeName: state.newInspectionSheetTypeName.trim()
            });
            if (res && res.success) {
                showToast(res.message || 'Inspection check copied successfully.');
                onClose(true);
            } else {
                showToast((res && res.message) || 'Failed to copy inspection check.');
                setState((st) => ({ ...st, btnLoader: false }));
            }
        } catch (err) {
            console.error('Failed to copy inspection sheet type:', err);
            showToast('Failed to copy inspection check.');
            setState((st) => ({ ...st, btnLoader: false }));
        }
    };

    return (
        <Grid container spacing={2} style={{ padding: '4px 2px' }}>
            <Grid item xs={12}>
                <InputLabel shrink required>
                    Copy From
                </InputLabel>
                <SelectBox
                    name="sourceInspectionSheetTypeID"
                    value={state.sourceInspectionSheetTypeID}
                    onChange={handleChange}
                    List={typeList}
                />
            </Grid>
            <Grid item xs={12}>
                <InputLabel shrink required>
                    New Inspection Check Name
                </InputLabel>
                <TextBox
                    name="newInspectionSheetTypeName"
                    value={state.newInspectionSheetTypeName}
                    onChange={handleChange}
                    placeholder="New Inspection Check Name"
                    autoFocus
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <SecondaryButton fullWidth onClick={handleCopy} isBtnLoader={state.btnLoader}>
                    Copy
                </SecondaryButton>
            </Grid>
            <Grid item xs={12} sm={6}>
                <SecondaryButton fullWidth onClick={() => onClose(false)}>
                    Cancel
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default CopyInspectionTypeModal;
